import {useContext} from 'external/react'
import Profile from 'context/profile-context'
import {getFullName} from 'utils/users'

import Settings from 'context/settings-context'

import { converseDisabled } from 'settings'

export default function useProfile () {
  const {update: updateSettings, state: {videos, items: settings = {}}} = useContext(Settings.Context)
  const {update, state: {info = {}, preferences = {}}} = useContext(Profile.Context)
  const {domain: domainName, institution = {}, Passport: passport = {}, individual = {}, expiration, dreyfouslabs} = info
  const {project = '', premium = false, locked = false, lockedMessage = {date: '2024-10-31 08:51:01.263888-04', message: 'Locked'}} = institution
  const noChat = converseDisabled || institution.noChat
  const fullName = getFullName(individual)
  return {update, domainName, institution, project, passport, fullName, premium, noChat, expiration, settings, preferences, videos, updateSettings, locked, lockedMessage, dreyfouslabs}
}

